import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { Status } from '../models/status';

@Injectable({
  providedIn: 'root'
})
export class StatusService {
  API_URL = `${environment.apiUrl}/status`;

  constructor(private http: HttpClient) {}

  getStatuses(): Observable<Status[]> {
    return this.http.get<Status[]>(this.API_URL).pipe(
      map(statuses => statuses.sort((a, b) => {
          const dateA = a.modifiedDate ? new Date(a.modifiedDate).getTime() : 0;
          const dateB = b.modifiedDate ? new Date(b.modifiedDate).getTime() : 0;
          if (dateB !== dateA) {
            return dateB - dateA;
          }
          return (b.id ?? 0) - (a.id ?? 0);
        }))
      );
  }

  addStatus(status: Status): Observable<Status> {
    return this.http.post<Status>(this.API_URL, status);
  }

  updateStatus(status: Status): Observable<Status> {
    return this.http.put<Status>(`${this.API_URL}/${status.id}`, status);
  }

  deleteStatus(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }

  getStatusByStatus(status: string): Observable<Status> {
    return this.http.get<Status>(`${this.API_URL}/status/${encodeURIComponent(status)}`);
  }
}
